import { SampleList } from './components/SampleList';
import './index.css';

const SamplesPage = () => {
  return <SampleList />;
};

export default SamplesPage;
